import React from "react";
import { RulesetContainer } from "../../../containers";
const Ruleset = (props) => {
  return <RulesetContainer {...props} />;
};

export default Ruleset;
